<!--
 * @Author: CJX
 * @Date: 2020-03-26 14:36:50
 * @LastEditors: LZL
 * @LastEditTime: 2021-05-06 12:12:00
 * @Description: 菜单权限维护
 -->

<template>
  <el-row
    type="flex"
    class="l-page l-page--nav"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :md="8"
      :span="10"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            菜单
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  ref="menuTree"
                  class="c-asideTree__tree o-tree-overflow--unset"
                  node-key="nodeCode"
                  highlight-current
                  :data="treeData"
                  :props="defaultProps"
                  :default-expanded-keys="defaultExpandedKeys"
                  :expand-on-click-node="false"
                  @node-click="handleSelectNode"
                />
              </div>
            </div>
          </hm-page-card>
        </div>
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :md="16"
      :span="14"
    >
      <div
        v-show="!activeMenuCode"
        class="js-no-menu"
      >
        请点击左侧有效菜单节点进行权限展示！
      </div>

      <div
        v-show="!activeMenuElements"
        class="js-no-menu"
      >
        当前菜单节点没有页面元素可进行授权配置！
      </div>

      <!-- 右侧内容：基础详情类布局 Start -->
      <!-- 右侧授权管理页面 Start -->
      <div
        v-show="!!activeMenuCode && !!activeMenuElements"
        class="l-page--inner l-page--detail"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 页面标题 -->
          <h2
            class="c-page__header-title"
          >
            授权管理
          </h2>
        </div>
        <!-- 页面头部 End -->

        <!-- 页面块内容 Start -->
        <div
          class="l-page__item l-page--detail__item"
        >
          <hm-page-card
            class="c-card--detail"
            title="菜单页面元素"
          >
            <el-alert
              title="选择【菜单页面元素】后，勾选权限进行授权，勾选后记得点击保存按钮！"
              type="warning"
              class="u-mg-b-8"
              :closable="false"
            />
            <el-button
              v-for="elItem in activeMenuElements"
              :key="elItem.elementCode"
              class="u-mg-r-8 u-mg-b-8"
              size="small"
              :type="activeMenuElementCode === elItem.elementCode ? 'primary' : 'default'"
              @click="handleClickActiveEl(elItem)"
            >
              {{ elItem.elementName }}
            </el-button>
          </hm-page-card>
        </div>
        <!-- 页面块内容 End -->

        <!-- 页面主内容：详情 Start -->
        <div
          class="l-page__body l-page--detail__body"
        >
          <div
            v-show="!activeMenuElementCode"
            class="js-no-menu"
          >
            请选择一个【菜单页面元素】进行权限授权操作！
          </div>
          <!--权限列表组件-->
          <menu-permission
            v-show="!!activeMenuElementCode"
            :menu-code="activeMenuCode"
            :element-code="activeMenuElementCode"
          />
        </div>
        <!-- 页面主内容：详情 End -->
      </div>
      <!-- 右侧授权管理页面 End -->
    </el-col>
    <!-- 右侧主面板模块 End -->
  </el-row>
</template>

<script>
import { getMenuTree } from './permission.service.js';
import MenuPermission from './permissionList';

export default {
  name: 'MenuList',
  components: {
    MenuPermission
  },
  data () {
    return {
      loading: false, // 页面loading状态

      /* 树组件配置 Start */
      treeData: [], // 树数据
      // 树组件默认参数配置
      defaultProps: {
        children: 'childNodes',
        label: 'nodeName'
      },
      defaultExpandedKeys: [], // 树组件默认展开节点key
      /* 树组件配置 End */

      activeMenuCode: null, // 当前激活的菜单代码
      activeMenuElementCode: null, // 当前激活的菜单页面元素代码
      menuElements: {}, // 系统路由所有菜单页面元素
      activeMenuElements: [] // 系当前激活的菜单的页面元素
    };
  },
  methods: {
    /**
     * @description: 获取菜单树
     * @param {String} _menuCode
     * @return {*}
     */
    getSystemMenuTree (_menuCode) {
      const _this = this;
      _this.loading = true;
      getMenuTree()
        .then(rsp => {
          // 菜单树赋值;
          if (rsp.data && rsp.data.length > 0) {
            this.defaultExpandedKeys = [rsp.data[0].nodeCode];
            _this.treeData = rsp.data;
          }
          if (_menuCode) {
            // dom加载后设置当前菜单项高亮
            _this.$nextTick(() => {
              _this.$refs.menuTree.setCurrentKey(_menuCode);
            });
          } else {
            // 菜单信息设为空
            this.menu = {};
          }
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 树结构选择节点，赋值激活菜单、激活菜单的页面元素
     * @param {Object} data
     * @param {Object} node
     * @return {*}
     */
    handleSelectNode (data, node) {
      if (data.nodeCode !== this.activeMenuCode) {
        this.activeMenuCode = data.nodeCode;
        this.activeMenuElements = this.menuElements[data.url];
        this.activeMenuElementCode = null;
      }
    },
    /**
     * @description: 格式化提交数据
     * @param {Array} _data 循环的数组
     * @param {String} parentPath 菜单路径
     * @return {*}
     */
    formatRoutes (_data, parentPath, routesArr) {
      _data.forEach(item => {
        // 拷贝节点信息
        const _routeData = JSON.parse(JSON.stringify(item));
        if (parentPath !== '/' && item.path[0] !== '/') {
          _routeData.path = parentPath + '/' + item.path;
        } else {
          _routeData.path = parentPath + item.path;
        }
        // 将节点信息存储到提交数组
        routesArr.push(_routeData);
        // 如果节点的子节点长度大于0，再次遍历
        if (item.children && item.children.length > 0) {
          this.formatRoutes(item.children, _routeData.path, routesArr);
        }
        // 删除多余节点
        delete (_routeData.component);
        delete (_routeData.beforeEnter);
        delete (_routeData.redirect);
        delete (_routeData.children);
      });
    },
    /**
     * @description: 格式化系统的路由配置
     * @param {*}
     * @return {*}
     */
    initRoutes () {
      const routes = this.$router.options.routes;
      const formateRoutes = [];
      this.formatRoutes(routes, '', formateRoutes);
      const elements = {};
      formateRoutes.map(item => {
        if (item.path && item.meta && item.meta.menuElements && item.meta.menuElements.length > 0) {
          // 忽略路由路径配置的不确定参数正则，如：system/:id?，菜单路径取固定部分
          const path = item.path.replace(/[^/]+\?$/g, '').replace(/\/$/g, '');
          elements[path] = item.meta.menuElements;
        }
      });
      this.menuElements = elements;
    },
    /**
     * @description: 点击选择页面元素进行授权管理
     * @param {*}
     * @return {*}
     */
    handleClickActiveEl (elItem) {
      this.activeMenuElementCode = elItem.elementCode;
    }
  },
  mounted () {
    this.initRoutes();
    // 获取菜单树
    this.getSystemMenuTree();
  }
};
</script>

<style scoped lang="scss">
.js-cancle-edit{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.js-no-menu{
  display: flex;
  align-items: center;
  justify-content: 100%;
  justify-content: center;
  height: 1005;
  height: 100%;
  font-size: 20px;
  letter-spacing: 2px;
  color: #bdbdbd;
}
</style>
